import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  typography: {
    fontFamily: 'Inter',
    h2: {
      fontWeight: 300,
      fontSize: 60,
    },
    h3: {
      fontWeight: 400,
      fontSize: 48,
    },
    h4: {
      fontWeight: 400,
      fontSize: 34,
    },
    h5: {
      fontWeight: 600,
      fontSize: 24,
    },
    h6: {
      fontWeight: 500,
      fontSize: 20,
    },
    h1: {
      fontWeight: 600,
      fontSize: 16,
    },
    caption: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '18px',
      letterSpacing: 0.4,
      display: 'inline-flex',
      color: '#757575',
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 1.5,
    },
    body2: {
      fontWeight: 400,
      fontSize: 14,
    },
    button: {
      fontWeight: 600,
      fontSize: 14,
    },
  },
  palette: {
    primary: { main: '#3E66FB', contrastText: '#fff' },
    secondary: { main: '#616161', contrastText: '#fff' },
    error: { main: '#EE334E', contrastText: '#fff' },
    warning: { main: '#FCB131', contrastText: '#fff' },
    success: { main: '#00A651', contrastText: '#fff' },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: 'none',
          padding: '10px 16px',
          textTransform: 'initial',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          backgroundColor: '#F5F7FF',
          borderRadius: 16,
          margin: 16,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          margin: 16,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        multiline: {
          padding: '0px !important',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          borderRadius: 8,
          '& .MuiOutlinedInput-input': {
            padding: '8.5px 10px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root': {
            fontSize: 12,
            fontWeight: 600,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          // backgroundColor: 'white',
          height: 'auto',
          fontSize: 14,
          // borderColor: '#E0E4E8',
          borderRadius: 8,
          padding: '10px 16px',
          // color: '#5D7383',
          '& .MuiChip-label': {
            padding: 0,
          },
          '& .MuiSvgIcon-root': {
            margin: 0,
            paddingLeft: 10,
          },
        },
      },
    },
  },
})
